<template>
   <Layout>
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Inicio</h4>
            </div>
         </div>
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Promociones y Ofertas</h4>
                  <b-carousel class="mt-3" style="text-shadow: 0px 0px 2px #000" controls indicators>
                  <b-carousel-slide :img-src="require('@/assets/notificaciones/banner-1.jpg')"></b-carousel-slide>
                  <b-carousel-slide :img-src="require('@/assets/notificaciones/banner-2.jpg')"></b-carousel-slide>
                  <b-carousel-slide :img-src="require('@/assets/notificaciones/banner-3.jpg')"></b-carousel-slide>
                  </b-carousel>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<script>
   import Layout from "@/layouts/Main";

   export default {
      name: 'Home',
      components: {
         Layout
      }
   }
</script>
